import { toast } from "@/core/components/ui/toast";

const THROTTLED_RESET_TOAST_ID = "password-reset-throttled";

// A refused send means a code went out recently, so offer a way to enter it
// rather than leaving the user stuck on the email form. It stays until acted
// on, and one id means a second refusal replaces the first instead of stacking.
export const showThrottledResetToast = (
  message: string,
  onEnterCode: () => void,
) =>
  toast.error(message, {
    id: THROTTLED_RESET_TOAST_ID,
    duration: Infinity,
    action: { label: "Enter code", onClick: onEnterCode },
  });

export const dismissThrottledResetToast = () =>
  toast.dismiss(THROTTLED_RESET_TOAST_ID);
